import React, { useEffect, useState } from 'react';
import { Box, Flex } from 'rebass';
import PropTypes from 'prop-types';
import { navigate, Script } from 'gatsby';

import {
  optionalPositions,
  getProjectEstimationInWeeks,
  getDefaultEstimationsByTeamMembers,
  updateEstimationsByTeamMembers,
} from '../../utils/mvp-calculator/estimate';
import MVPCalculatorResultSendPDFForm from './MVPCalculatorResultSendPDFForm';
import { H1Text } from '../Typography/styled';
import MVPCalculatorResultEstimation from './MVPCalculatorResultEstimation';
import colors2 from '../../utils/theme/theme2/colors2';

const styles = {
  container: {
    maxWidth: 810,
    width: '100%',
    marginTop: '20px',
    paddingTop: 60,
  },
  controls: {
    marginBottom: 100,
  },
  text: {
    color: colors2.black,
    textAlign: 'center',
  },
  estimationDetails: {
    marginTop: '60px',
    width: '100%',
  },
};

const MVPCalculatorResult = ({ totalAmount, reportDataBySteps, handleUpdateTotalCost }) => {
  const [isPDFSent, setPDFsentState] = useState(false);
  const [projectEstimation, setProjectEstimation] = useState(0);
  const [estimationsByMembers, setEstimationsByMembers] = useState(() =>
    getDefaultEstimationsByTeamMembers(reportDataBySteps)
  );

  /**
   * @param {string} id
   * @param {string} position
   * @param {number} estimation
   * @param {string} action 'remove' | 'add'
   */

  const handleMemberActionClick = (id, position, estimation, cost, action) => {
    if (optionalPositions.includes(position)) {
      handleUpdateTotalCost(cost, action === 'add');
    }

    const updatedEstimationsByMembers = estimationsByMembers.map((estimationData) => {
      if (estimationData.id !== id) {
        return estimationData;
      }

      return {
        ...estimationData,
        canBeAdded: action === 'remove',
        canBeRemoved: action === 'add',
      };
    });

    setEstimationsByMembers(() => {
      const updatedRecalculatedEstimationsByMembers = updateEstimationsByTeamMembers(
        updatedEstimationsByMembers,
        reportDataBySteps
      );

      setProjectEstimation(getProjectEstimationInWeeks(updatedRecalculatedEstimationsByMembers));

      return updatedRecalculatedEstimationsByMembers;
    });
  };

  useEffect(() => {
    const defaultEstimationsByMembers = getDefaultEstimationsByTeamMembers(reportDataBySteps);
    setProjectEstimation(getProjectEstimationInWeeks(defaultEstimationsByMembers));
    setEstimationsByMembers(defaultEstimationsByMembers);
  }, [reportDataBySteps]);

  useEffect(() => {
    if (isPDFSent) {
      navigate('/thank-you');
    }
  }, [isPDFSent]);

  return (
    <Flex flexDirection="column" alignItems="center">
      <Flex flexDirection="column" style={styles.container}>
        <Flex flexDirection="column" alignItems="center" justifyContent="center">
          {!isPDFSent && (
            <>
              <H1Text style={{ textAlign: 'center' }}>Get your project estimate</H1Text>
              <MVPCalculatorResultSendPDFForm
                reportDataBySteps={reportDataBySteps}
                totalAmount={totalAmount}
                projectEstimation={projectEstimation}
                estimationByMembers={estimationsByMembers.filter(({ canBeAdded }) => !canBeAdded)}
                handleFormDataWillSent={() => {
                  setPDFsentState(true);
                }}
              />

              <Box id="project_duration" style={styles.estimationDetails}>
                <MVPCalculatorResultEstimation
                  title="Project duration"
                  value={`${projectEstimation} weeks`}
                />
              </Box>
            </>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

MVPCalculatorResult.propTypes = {
  totalAmount: PropTypes.number.isRequired,
  // ! do something about propType object
  // eslint-disable-next-line react/forbid-prop-types
  reportDataBySteps: PropTypes.arrayOf(PropTypes.object).isRequired,
};

MVPCalculatorResult.defaultProps = {};

export default MVPCalculatorResult;
